<template lang="pug">
.event-information(:class="'campaign'")
  .campaignInfo
    .tabCampaignList
      .tabs-component
        ul.tabCampaignListInner
          v-touch(tag="li", v-for="(tab, index) in tabs", :key="index", :class="{active: currentTab === tab.value}", @tap="changeTab(tab.value)")
            button
      components(:is="'AwardBox'", v-if="visibleAwardBox", :campaign="taskList[0]")
    .list-wrap
      components(:is="currentTab", v-if="visibleComponent", :lastUpdate="lastUpdate", :taskList="taskList")
      p.nullInfo(v-else) 暂无资料
</template>

<script>
import AwardBox from './awardBox'
import ruleBoard from './ruleBoard'
import currentLeaderBoard from './currentLeaderBoard'
import historyLeaderBoard from './historyLeaderBoard'
export default {
  props: ['lastUpdate', 'taskList', 'hasLoaded'],
  components: {
    ruleBoard,
    currentLeaderBoard,
    historyLeaderBoard,
    AwardBox
  },
  methods: {
    changeTab (val) {
      this.currentTab = val
    }
  },
  data () {
    return {
      currentTab: 'ruleBoard',
      tabs: [{
        value: 'ruleBoard'
      }, {
        value: 'currentLeaderBoard'
      }, {
        value: 'historyLeaderBoard'
      }]
    }
  },
  computed: {
    visibleComponent () {
      return this.hasLoaded || this.currentTab === 'ruleBoard'
    },
    visibleAwardBox () {
      return this.hasLoaded && this.$route.query.playerId
    }
  }
}
</script>

<style lang="scss">
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
@import '../assets/styles/base/base';
@import '../assets/styles/base/table';

.tabContentWrapper {
  width: 100%;
  margin-top: -40%;
  position: relative;
  flex: 1;
  // display: flex; // online
  // align-items: center; //online
  // justify-content: center; //online
  @include breakpoint(568px){
    margin-top: -17%;
  }
}

.tabContent {
  border-radius: 8px;
  box-sizing: border-box;
  .tabItemRankList {
    height: 60px;
    display: flex;
    justify-content: space-between;
    background: $black;
    border-radius: 40px;
    margin-bottom: 2rem;
    @include breakpoint(1024px){
      height: 80px;
      margin-bottom: 5rem;
    }
    li {
      flex-basis: calc(100% / 2);
      height: 60px;
      box-sizing: border-box;
      position: relative;
      @include breakpoint(1024px) {
        flex-basis: calc(100% / 2 - 10px);
        height: 80px;
      }
      button {
        width: 100%;
        height: 60px;
        border-radius: 40px;
        font-weight: bold;
        background: transparent;
        border: 0;
        outline: none;
        cursor: pointer;
        transition: all .3s;
        color: $white;
        @include rem(font-size, 2.5rem);
        @include breakpoint(1024px) {
          height: 80px;
        }
        &:before {
          content: '';
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 10px 0 10px;
          border-color: transparent;
          position: absolute;
          left: calc(50% - 10px);
          bottom: -10px;
        }
      }
      &.active {
        button {
          background: $blue;
          &:before {
            border-color: $blue transparent transparent transparent;
          }
        }
      }
    }
  }
  .tabItemList {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include breakpoint(1024px){
      height: 85px;
    }
    li {
      height: 48px;
      display: flex;
      box-sizing: border-box;
      flex: 1;
      margin: 0 5px;
      @include breakpoint(1024px){
        height: 85px;
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      button {
        border-radius: 10px 10px 0px 0px;
        width: 100%;
        height: 48px;
        font-weight: bold;
        border: 0;
        outline: none;
        cursor: pointer;
        transition: all .3s;
        color: $darker-gray;
        @include TabItemBtn-N;
        @include rem(font-size, 1.8rem);
        @include breakpoint(768px){
          @include rem(font-size, 2rem);
        }
        @include breakpoint(1024px){
          height: 85px;
          @include rem(font-size, 2.5rem);
        }
        &:hover {
          color: $darker-gray;
        }
      }
      &.active {
        button {
          height: 48px;
          color: $blue;
          @include TabItemBtn-A;
          @include breakpoint(1024px){
            height: 85px;
          }
        }
      }
    }
  }
  .itemlist-wrap {
    background: $ligten-blue;
    border-radius: 0px 0px 10px 10px;
    .rankIcon {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconItem {
        margin: 1rem auto;
        width: 80px;
        height: 80px;
        @include breakpoint(1024px) {
          width: 70px;
          height: 70px;
        }
        &.caiShen_Item {
          background: url('../assets/images/award_g.png') no-repeat center center;
          background-size: cover;
        }
        &.dragon_Item {
          background: url('../assets/images/award_s.png') no-repeat center center;
          background-size: cover;
        }
        &.fishKing_Item {
          background: url('../assets/images/award_king.png') no-repeat center center;
          background-size: cover;
        }
      }
    }
    .personal {
      .badge {
        background-color: transparent;
        border: 1px solid $border-gray;
      }
    }
    .personalInner {
      .badge {
        border: 1px solid $border-gray;
        &.gold {
          &:before {
            background: url('../assets/images/award_g.png') no-repeat center center;
            background-size: cover;
          }
        }
        &.silver {
          &:before {
            background: url('../assets/images/award_s.png') no-repeat center center;
            background-size: cover;
          }
        }
      }
      .allTotal {
        background: $light-gray;
      }
    }
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 2em 0;
      .moreBtn {
        border: 0;
        outline: none;
        cursor: pointer;
        width: 150px;
        height: 50px;
        padding: 12px 20px;
        display: block;
        color: $white;
        font-weight: bold;
        text-decoration: none;
        text-align: center;
        border-radius: 20px;
        box-shadow: 0px 3px 0px $more-shadow;
        @include rem(font-size, 1.5rem);
        @include moreBtn-bg;
        @include breakpoint(768px){
          padding: 4px 20px;
          @include rem(font-size, 1.6rem);
        }
        @include breakpoint(1024px){
          width: 220px;
          height: 63px;
          @include rem(font-size, 2.4rem);
        }
      }
    }
  }
}

.campaignInfo {
  width: 100%;
  box-sizing: border-box;
  @include breakpoint(568px){
    width: 450px;
    // width:80%;
    margin: 0 auto;
  }
  @include breakpoint(1024px){
    width: 980px;
    margin: 0 auto;
  }
}

.tabCampaignList {
  margin-bottom: 10px;
}

.tabCampaignListInner {
  display: flex;
  justify-content: center;
  align-items: center;
  @include breakpoint(1024px) {
    justify-content: space-around;
  }
  li {
    flex-basis: calc(100% / 3);
    @include breakpoint(1024px) {
      flex-basis: 250px;
    }
    &:first-child {
      button {
        background: url('../assets/images/btn1_primary.png') no-repeat left top;
        background-size: contain;
      }
      &:hover button {
        @include breakpoint(1024px) {
          background: url('../assets/images/btn1_hover.png') no-repeat left top;
          background-size: contain;
        }
      }
      &.active button {
        background: url('../assets/images/btn1_active.png') no-repeat left top;
        background-size: contain;
      }
    }
    &:nth-child(2) {
      button {
        background: url('../assets/images/btn2_primary.png') no-repeat left top;
        background-size: contain;
      }
      &:hover button {
        @include breakpoint(1024px) {
          background: url('../assets/images/btn2_hover.png') no-repeat left top;
          background-size: contain;
        }
      }
      &.active button {
        background: url('../assets/images/btn2_active.png') no-repeat left top;
        background-size: contain;
      }
    }
    &:last-child {
      button {
        background: url('../assets/images/btn3_primary.png') no-repeat left top;
        background-size: contain;
      }
      &:hover button {
        @include breakpoint(1024px) {
          background: url('../assets/images/btn3_hover.png') no-repeat left top;
          background-size: contain;
        }
      }
      &.active button {
        background: url('../assets/images/btn3_active.png') no-repeat left top;
        background-size: contain;
      }
    }
    button {
      outline: none;
      border: 0;
      width: 100%;
      padding-top: calc(100% * 250 / 250);
      cursor: pointer;
      transition: all .3s;
    }
  }
}

.list-wrap {
  margin-bottom: 5em;
}

.nullInfo {
  width: 100%;
  text-align: center;
  margin: 0;
  @include rem(font-size, 1.8rem);
  @include breakpoint($iSE_p){
    @include rem(font-size, 1.6rem);
  }
  @include breakpoint(1366px){
    @include rem(font-size, 2.4rem);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/infoTabs.vue